module.exports = __webpack_public_path__ + "static/media/IconoPila1.98a799f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/IconoPila1.svg
// module id = 757
// module chunks = 0